export const CONSUMER_HOMEPAGE_PREFIX = "consumer.homePage";

export const HOMEPAGE_CONTAINER_STYLES = {
  py: 4,
  px: [4, 6],
  maxWidth: "lg",
  ml: "auto",
  mr: "auto"
};
